import React from "react";
import { Link } from "react-router-dom";
import { Ticket, Clock, ArrowRight, CreditCard } from "lucide-react";
import { motion } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";

const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_ticketing-transport/artifacts/5p6cedk3_1000607872.png";

export default function HomeTickets() {
  const { user, company } = useAuth();
  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center gap-6">
        <img src={LOGO_URL} alt="Transport.pro" className="w-24 h-24 md:w-28 md:h-28 rounded-2xl object-cover shadow-lg" data-testid="menu-logo" />
        <div>
          <div className="text-xs font-semibold tracking-widest uppercase text-orange-500">Bonjour {user?.full_name?.split(" ")[0]}</div>
          <h1 className="font-display text-3xl md:text-4xl font-bold mt-1">Menu — {company?.name || "Transport.pro"}</h1>
          <p className="mt-2 text-slate-500 flex items-center gap-2">
            <CreditCard className="w-4 h-4 text-orange-500" /> Vente en ligne — paiements électroniques uniquement
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 }}>
          <Link to="/app/book/reservation?context=menu" data-testid="btn-billet-reservation" className="group block">
            <div className="relative overflow-hidden rounded-3xl bg-orange-500 text-white p-8 md:p-10 min-h-[260px] flex flex-col justify-between hover:-translate-y-1 transition-transform shadow-lg shadow-orange-500/20">
              <div className="absolute -right-8 -top-8 w-48 h-48 rounded-full bg-white/10 blur-2xl"></div>
              <div className="absolute right-6 top-6"><Ticket className="w-10 h-10 opacity-70" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest font-semibold opacity-80">Billet</div>
                <div className="font-display text-3xl md:text-4xl font-bold mt-2">Réservation</div>
                <div className="mt-2 text-white/85 max-w-xs">Réservez un billet pour une date et un horaire précis.</div>
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold">
                Commencer <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </Link>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
          <Link to="/app/book/realtime?context=menu" data-testid="btn-billet-realtime" className="group block">
            <div className="relative overflow-hidden rounded-3xl bg-slate-900 dark:bg-slate-900 text-white p-8 md:p-10 min-h-[260px] flex flex-col justify-between hover:-translate-y-1 transition-transform border border-slate-200/10 shadow-lg">
              <div className="absolute -left-8 -bottom-8 w-48 h-48 rounded-full bg-orange-500/25 blur-2xl"></div>
              <div className="absolute right-6 top-6"><Clock className="w-10 h-10 opacity-70" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest font-semibold opacity-80">Billet</div>
                <div className="font-display text-3xl md:text-4xl font-bold mt-2">Temps réel</div>
                <div className="mt-2 text-white/70 max-w-xs">Émettez un billet immédiat via paiement électronique.</div>
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold">
                Commencer <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </Link>
        </motion.div>
      </div>

      <div className="text-xs text-slate-500 border-t border-slate-200 dark:border-slate-800 pt-4">
        💡 Pour une vente au guichet incluant les espèces, utilisez le module <Link to="/app/cash" className="text-orange-500 font-medium hover:underline">Caisse</Link>.
      </div>
    </div>
  );
}
